import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ProductsSettingsForm from "./ProductsSettingsForm";

function ProductsSettings() {
  return (
    <section className="setting position-relative py-3">
      <Container>
        <Row className="justify-content-center">
          <Col lg="12">
            <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
              Settings for products
            </h4>
          </Col>
          <ProductsSettingsForm />
        </Row>
      </Container>
    </section>
  );
}

export default ProductsSettings;
